<script setup lang="ts">
import { KanbanComments } from '@widgets/kanban-comments'

import { useSectionTaskInfoUpdate } from '../model/section-task-info-update.hook'
import TaskInfoLayer from './TaskInfoLayer.vue'
import ButtonTaskUpdate from './info/ButtonTaskUpdate.vue'
import TaskRelatedCreate from './info/TaskRelatedCreate.vue'
import TaskCommon from './task-info/TaskCommon.vue'
import TaskGeneralInfoUpdate from './task-info/TaskGeneralInfoUpdate.vue'
import TaskResponsible from './task-info/TaskResponsible.vue'
import TaskRelations from './task-info/TaskRelations.vue'
import TaskAdditionalDetails from './task-info/TaskAdditionalDetails.vue'

defineOptions({
  name: 'SectionTaskInfoUpdate',
})

const {
  refLabel,
  refId,
  saveCommentApi,
  updateCommentApi,
} = useSectionTaskInfoUpdate()
</script>

<template>
  <TaskInfoLayer
    title="Task"
    :label="refLabel"
    :task-id="refId"
  >
    <template #general>
      <TaskGeneralInfoUpdate />
    </template>
    <template #responsible>
      <TaskResponsible />
    </template>
    <template #relations>
      <TaskRelations />
    </template>
    <template #common>
      <TaskCommon />
    </template>
    <template #default>
      <TaskAdditionalDetails />
      <KanbanComments
        title="Comments"
        fullwidth
        :save-api="saveCommentApi"
        :update-api="updateCommentApi"
      />
    </template>
    <template #actions>
      <TaskRelatedCreate />
      <ButtonTaskUpdate />
    </template>
  </TaskInfoLayer>
</template>
